import React from 'react';
import { McSelect } from '@maersk-global/mds-react-wrapper';
import { DatabaseType } from '../../utils/terminalConfig';

interface DatabaseSelectProps {
    value: DatabaseType;
    onChange: (value: DatabaseType) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
    variant?: 'NearRealtime' | 'Snapshot';
}

export const DatabaseSelect: React.FC<DatabaseSelectProps> = ({
    value,
    onChange,
    label = "Database Type",
    placeholder = "Select database type",
    required = false,
    disabled = false,
    className,
    style,
    variant
}) => {
    const options = [
        { label: variant === 'NearRealtime' ? 'Near Realtime Data (Oracle)' : 'Oracle', value: 'ORACLE' },
        { label: variant === 'Snapshot' ? 'Snapshots (Postgres)' : 'PostgreSQL', value: 'POSTGRESQL' },
        { label: 'External Connection', value: 'EXTERNAL' },
    ];

    return (
        <McSelect
            label={label}
            placeholder={placeholder}
            value={value}
            data={options}
            optionselected={(e: any) => {
                const val = e.detail?.value || e.detail;
                onChange(val as DatabaseType);
            }}
            required={required}
            disabled={disabled}
            className={className}
            style={style}
        />
    );
};
